import { Menu as AntMenu } from 'antd'
import { MenuProps as AntMenuProps } from 'antd/lib/menu'
import { MenuItemProps as AntMenuItemProps } from 'antd/lib/menu/MenuItem'
import styled from 'styled-components'
import { FC } from 'react'

import { Color, ThemeWrapper, themeColor } from '../theme'

export type MenuVariant = 'default' | 'primary' | 'secondary'

export interface MenuProps extends AntMenuProps {
  variant?: MenuVariant
}

const backgrounds: Record<MenuVariant, Color> = {
  default: 'white',
  primary: 'primary',
  secondary: 'secondary'
}

const activeBackgrounds: Record<MenuVariant, Color> = {
  default: 'bgPrimary',
  primary: 'primaryLighter',
  secondary: 'secondaryLighter'
}

const colors: Record<MenuVariant, Color> = {
  default: 'textPrimary',
  primary: 'textPrimaryInverse',
  secondary: 'textPrimaryInverse'
}

const disabledColors: Record<MenuVariant, Color> = {
  default: 'textMuted',
  primary: 'textMuted',
  secondary: 'textMuted'
}

const StyledMenu = styled(AntMenu)<MenuProps>`
  background: ${({ variant }) => themeColor(backgrounds[variant || 'default'])}!important;
`

export const Menu: FC<MenuProps> = props => (
  <ThemeWrapper>
    <StyledMenu {...props} />
  </ThemeWrapper>
)

export interface MenuItemProps extends AntMenuItemProps {
  variant?: MenuVariant
  selected?: boolean
}

const StyledMenuItem = styled(AntMenu.Item)<MenuItemProps>`
  /* font-weight: bold; */
  background: ${({ variant, selected }) =>
    themeColor(selected ? activeBackgrounds[variant || 'default'] : backgrounds[variant || 'default'])};

  color: ${({ variant, disabled }) =>
    themeColor(disabled ? disabledColors[variant || 'default'] : colors[variant || 'default'])}!important;

  border-radius: 0px !important;

  &:hover {
    background: ${({ variant }) => themeColor(activeBackgrounds[variant || 'default'])}!important;
  }
`

export const MenuItem: FC<MenuItemProps> = props => (
  <ThemeWrapper>
    <StyledMenuItem {...props} />
  </ThemeWrapper>
)
